import { render, staticRenderFns } from "./emailConfig.vue?vue&type=template&id=35d04472&scoped=true"
import script from "./emailConfig.vue?vue&type=script&lang=js"
export * from "./emailConfig.vue?vue&type=script&lang=js"
import style0 from "./emailConfig.vue?vue&type=style&index=0&id=35d04472&prod&lang=scss&scoped=true"
import style1 from "./emailConfig.vue?vue&type=style&index=1&id=35d04472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d04472",
  null
  
)

export default component.exports